const initialFormState = {
    location_name: "",
    street_address: "",
    city: "",
    state: "CA",
    zip_code: "",
    location_address: "",
    lease_amount: 0,
    location_type: "",
    location_hours: "",
    tax_status: "",
    location_spaces: "",
    invoicing_type: "Variable",
    is_active: 1,
    stage: "Live",
    operating_structure: "Non Lease",
    monthly_parking_capacity: 0,
    is_cash_accepted: 0,
    is_monthly_parking_active: 0,
    partner_remittance_terms: "",
    partner_remittance_amount: 0,
    partner_remittance_percent: 0,
    labor_hours_cap: 0,
    account_manager_id: 3,
    invoice_directives: "",
    manager_labor_rate: 0,
    attendant_labor_rate: 0,
    management_fee: 0,
    insurance_fee: 0,
    parking_lot_fee: 0,
    permit_meter_fee: 0,
    tech_fee: 0,
    ops_supplies_fee: 0,
    partner_remittance_fee: 0,
    parking_lot_cost: 0,
    contract_files: [],
    amendment_files: [],
    finance_terms: [],
    third_party_platforms: [],
    parking_types: [],
    fileSections: [],
    parking_lots: [],
    hours: {
        monday: { active: false, open: "", close: "" },
        tuesday: { active: false, open: "", close: "" },
        wednesday: { active: false, open: "", close: "" },
        thursday: { active: false, open: "", close: "" },
        friday: { active: false, open: "", close: "" },
        saturday: { active: false, open: "", close: "" },
        sunday: { active: false, open: "", close: "" }
    }
}

export default initialFormState;